import { stringToIndex } from '@/utils/strings';

// Brand colours live only in `:root` and are never overridden in `.dark`, so the
// foreground is pinned to the swatch rather than to a theme token that would flip.
const AVATAR_SWATCHES = [
  'bg-brand-cyan-cornflower-blue text-white',
  'bg-brand-red text-white',
  'bg-brand-claret text-white',
  'bg-brand-midnight-blue text-white',
  'bg-brand-dark-emerald-green text-white',
  'bg-brand-emerald-green text-black',
  'bg-brand-jordy-blue text-black',
  'bg-brand-plum text-black',
  'bg-brand-yellow text-black',
];

/** The swatch a seed (a stable id such as an email) always gets */
export const avatarSwatchClass = (seed: string): string =>
  AVATAR_SWATCHES[stringToIndex(seed, AVATAR_SWATCHES.length)];
